import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  FieldTemplateOne,
  renderFieldTemplateOne,
} from "../../PlantillasBloquesTabla"

const ResultadoLiquidaciones = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()
  const fieldsNoTributan: FieldTemplateOne[] = [
    {
      label: t("taxSummary.declaracion.resultadoLiquidaciones.box1"),
      code: "casilla95",
      inputNumber: "95",
      value: values?.casilla95,
      disabled: false,
    },
    {
      label: t("taxSummary.declaracion.resultadoLiquidaciones.box2"),
      code: "casilla96",
      inputNumber: "96",
      value: values?.casilla96,
      disabled: true,
    },
    {
      label: t("taxSummary.declaracion.resultadoLiquidaciones.box3"),
      code: "casilla524",
      inputNumber: "524",
      value: values?.casilla524,
      disabled: true,
    },
    {
      label: t("taxSummary.declaracion.resultadoLiquidaciones.box4"),
      code: "casilla97",
      inputNumber: "97",
      value: values?.casilla97,
      disabled: !!values?.casilla98,
    },
    {
      label: t("taxSummary.declaracion.resultadoLiquidaciones.box5"),
      code: "casilla98",
      inputNumber: "98",
      value: values?.casilla98,
      disabled: !!values?.casilla97,
    },
    {
      label: t("taxSummary.declaracion.resultadoLiquidaciones.box6"),
      code: "casilla662",
      inputNumber: "662",
      value: values?.casilla662,
      disabled: false,
    },
  ]

  const fieldsTributan: FieldTemplateOne[] = [
    {
      label: t("taxSummary.declaracion.resultadoLiquidaciones.box7"),
      code: "casilla525",
      inputNumber: "525",
      value: values?.casilla525,
      disabled: true,
    },
    {
      label: t("taxSummary.declaracion.resultadoLiquidaciones.box8"),
      code: "casilla526",
      inputNumber: "526",
      value: values?.casilla526,
      disabled: true,
    },
  ]

  return (
    <div
      title='Administraciones'
      className='tw-w-full tw-px-6 tw-pb-6'
    >
      <div className='tw-flex tw-flex-col'>
        <p className='tw-font-medium tw-text-sm'>
          {t("taxSummary.declaracion.resultadoLiquidaciones.text1")}
        </p>

        {/* Primeros 3 campos (95, 96, 524) */}
        {fieldsNoTributan
          .slice(0, 3)
          .map((field) => renderFieldTemplateOne(field, setValue))}

        {/* Bloque especial: 97 y 98 agrupados */}
        <div className='tw-grid tw-grid-cols-5 tw-items-center tw-gap-2 tw-border-b tw-border-gray-200 tw-py-3'>
          <div className='tw-col-span-4 tw-text-sm'>
            {t("taxSummary.declaracion.resultadoLiquidaciones.text2")}
          </div>
          <div className='tw-col-span-1'>
            {fieldsNoTributan.slice(3, 5).map((field) => (
              <div
                key={field.code}
                className='first:tw-border-b first:tw-border-gray-200 first:tw-pb-3 last:tw-pt-3'
              >
                <div className='tw-col-span-1 tw-text-xs tw-pl-2'>
                  {field.label}
                </div>
                <div className='tw-col-span-1'>
                  <InputCurrencyGroup
                    suffix='€'
                    value={field.value as number}
                    placeholder='0,00'
                    className='tw-w-full tw-h-full tw-text-sm'
                    numberGroup={String(field.inputNumber)}
                    disabled={field.disabled}
                    onChange={(value) => setValue(`${field.code}`, value)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Último campo (662) */}
        {fieldsNoTributan
          .slice(5)
          .map((field) => renderFieldTemplateOne(field, setValue))}
      </div>

      <div className='tw-flex tw-flex-col tw-pt-3'>
        <p className='tw-font-medium tw-text-sm'>
          {t("taxSummary.declaracion.resultadoLiquidaciones.text3")}
        </p>
        {fieldsTributan.map((field) => renderFieldTemplateOne(field, setValue))}
      </div>
    </div>
  )
}

export default ResultadoLiquidaciones
